import React from 'react'

function EL_ValidateFromDB() {
  return (
    <div>EL_ValidateFromDB</div>
  )
}

export default EL_ValidateFromDB